import { toastError, toastSuccess } from '@onestep/coreui/Toast';
import { map, upperCase } from 'lodash';

import { PROCEDURE_OPTIONS } from '@/consts/selectOptions';

import { ReactComponent as SurgeryIcon } from '../../../../assets/icons/timeline/surgeryIcon.svg';
import useClinicalInfoService from '../../../../services/patientProfileService/clinicalInfo';
import { eventType } from '../NewEventModal';

export default function useSurgeryEvent(patientUuid: string) {
  const { data, surgery } = useClinicalInfoService(patientUuid);

  const deleteSurgery = async (id: number) => {
    try {
      await surgery.deleteSurgery(id);
      toastSuccess({ content: `The event Deleted Successfully!` });
    } catch (error) {
      toastError({ content: 'Failed to delete event!' });
    }
  };

  return map(data?.surgeries ?? [], ({ eventDate, name, id }) => ({
    name: 'Surgery',
    date: eventDate,
    icon: SurgeryIcon,
    description:
      PROCEDURE_OPTIONS?.find((option) => option.value === name?.toLowerCase())?.label ||
      upperCase(name),
    isToShowUpdateIcons: true,
    id: id as number,
    tabName: eventType.surgery,
    onDelete: deleteSurgery,
  }));
}
